export const table_titles = [
	{ name: "#", size: 5, order: "" },
	{ name: "Nombre", size: 15, order: "name" },
	{ name: "Grupos Campos", size: 10, order: "estate_parent_name" },
	{ name: "# Hectárea", size: 10, order: "" },
	{ name: "Hora Apertura", size: 10, order: "time_open" },
	{ name: "Hora Cierre", size: 10, order: "time_close" },
	{ name: "Tipo de bodega", size: 15, order: "" },
	{ name: "Acción", size: 10, order: "" },
];
